import { IFitoListItem } from '~/Components';
import { IFitoListSettings } from './interfaces';

export const filterList = <T extends object>(
  unstructuredList: T[],
  settings: IFitoListSettings,
  searchText: string,
  initializeStructuredList: (unstructuredList: T[]) => IFitoListItem[],
) => {
  let structuredFilteredList = initializeStructuredList(unstructuredList);

  // if the search setting is turned on and there is some text entered =>
  // return only items that contain some text that match the inputted one
  if (settings.search && searchText?.length > 0) {
    structuredFilteredList = structuredFilteredList.filter(
      (item) =>
        item.header?.toLowerCase().match(searchText.toLowerCase()) ||
        item.subheader?.toLowerCase().match(searchText.toLowerCase()),
    );
  }

  // if the select setting is turned on, returned selected items first then unselected.
  if (settings.select) {
    structuredFilteredList = [
      ...structuredFilteredList.filter((item) => item.checked),
      ...structuredFilteredList.filter((item) => !item.checked),
    ];
  }

  return structuredFilteredList;
};
